import React from 'react'
import Welcome from '../components/Welcome'

function Landing() {
  return (
    <div>
        <Welcome></Welcome>
    </div>
  )
}

export default Landing
